// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { BEBaseElement } from './BEBaseElement';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 方法基类 实体类
 * 方法基类
 */
export abstract class BaseMethod extends BEBaseElement {
  /** 数据类型 : 返回数据类型，无返回使用void */
  private _returnDataType: EnumDataType;

  /** 设置：数据类型 */
  public get returnDataType() {
    return this._returnDataType;
  }

  /** 获取：数据类型 */
  public set returnDataType(value: EnumDataType) {
    this._returnDataType = value;
  }

  /** 引用类型 : 引用类型，当数据类型为引用的时候有效 */
  private _returnReferenceType: string;

  /** 设置：引用类型 */
  public get returnReferenceType() {
    return this._returnReferenceType;
  }

  /** 获取：引用类型 */
  public set returnReferenceType(value: string) {
    this._returnReferenceType = value;
  }

  /** 显示名称 : 返回值显示名称 */
  private _returnDisplayName: string;

  /** 设置：显示名称 */
  public get returnDisplayName() {
    return this._returnDisplayName;
  }

  /** 获取：显示名称 */
  public set returnDisplayName(value: string) {
    this._returnDisplayName = value;
  }

  /** 描述 : 返回值描述 */
  private _returnDescription: string;

  /** 设置：描述 */
  public get returnDescription() {
    return this._returnDescription;
  }

  /** 获取：描述 */
  public set returnDescription(value: string) {
    this._returnDescription = value;
  }

  /** 是否是集合 : 返回值是否是集合 */
  private _returnIsCollection: boolean;

  /** 设置：是否是集合 */
  public get returnIsCollection() {
    return this._returnIsCollection;
  }

  /** 获取：是否是集合 */
  public set returnIsCollection(value: boolean) {
    this._returnIsCollection = value;
  }

  constructor() {
    super();
    this._returnDataType = EnumDataType.String;
    this._returnReferenceType = '';
    this._returnDisplayName = '';
    this._returnDescription = '';
    this._returnIsCollection = false;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: BaseMethod, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.returnDataType = element.returnDataType;
      this.returnReferenceType = element.returnReferenceType;
      this.returnDisplayName = element.returnDisplayName;
      this.returnDescription = element.returnDescription;
      this.returnIsCollection = element.returnIsCollection;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.returnDataType = json.ReturnDataType as EnumDataType;
    this.returnReferenceType = json.ReturnReferenceType;
    this.returnDisplayName = json.ReturnDisplayName;
    this.returnDescription = json.ReturnDescription;
    this.returnIsCollection = json.ReturnIsCollection;
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.ReturnDataType = this.returnDataType;
    json.ReturnReferenceType = this.returnReferenceType;
    json.ReturnDisplayName = this.returnDisplayName;
    json.ReturnDescription = this.returnDescription;
    json.ReturnIsCollection = this.returnIsCollection;
  }

  protected buildPGContext(context: PGContext): void {
    super.buildPGContext(context);
    // Add row
    context.addRow('返回值', 'returnDataType', '数据类型', EnumDataType.Reference, this.returnDataType, true, '返回数据类型，无返回使用void', 'EnumDataType', 'PGRowEnumValue');
    context.addRow('返回值', 'returnReferenceType', '引用类型', EnumDataType.String, this.returnReferenceType, true, '引用类型，当数据类型为引用的时候有效', '', 'PGRowDataTypeValue:all');
    context.addRow('返回值', 'returnDisplayName', '显示名称', EnumDataType.String, this.returnDisplayName, true, '返回值显示名称', '', '');
    context.addRow('返回值', 'returnDescription', '描述', EnumDataType.String, this.returnDescription, true, '返回值描述', '', '');
    context.addRow('返回值', 'returnIsCollection', '是否是集合', EnumDataType.Bool, this.returnIsCollection, true, '返回值是否是集合', '', '');
  }
}
